import React, { PropTypes } from 'react';
import LoginWarningPage from './LoginWarningPage';
import LoginOMBMessage from './LoginOMBMessage';
import Button from '../../common/Button';

export const backdropStyle = {
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 3,
  backgroundColor: '#000',
  opacity: 0.5
};

const LoginForm = ({
  ombForm,
  ombForm2
}) => {
  let loginGovBtnText = <div>Sign in with <span>Login.gov</span></div>;
  let createAccountBtnText = <div>New User? Create an ITA Account</div>;
  return (
    <div className="modal-plus-login ita-login-form">
      <div className="login-header">
        <img src={require('../../../images/ita-logo.png')} className="img-responsive ita-logo" alt="OSHA Injury Tracking Application - Logo" />
        <h1 className="login-header-text">Log In to OSHA's Injury Tracking Application (ITA)</h1>
      </div>
      <div>
        <div className="login-page">
          <div className="mobile-border-container">
            <div className="panel-body">
              <div className="centered">
                <div className="row full-width">
                  <Button className="login-btn btn btn-block usa-button sign-in-logo" id="osha-ita-login-url" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/saml/drupal_login/saml_dol_osha_ita_ddp_dev';
                  }} value={loginGovBtnText} title="Access ITA through Login.gov"/>
                </div>
                <div className="row">
                  <h3>or</h3>
                </div>
                <div className="row half-width">
                  <Button className="btn btn-block usa-button--big login-form-btn" id="ita-action-button" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/injuryreporting/ita/create-account';
                  }} value={createAccountBtnText} title="Create Account in ITA"/>
                </div>
              </div>
              <div className="divider"/>
              <div className="login-page-text-box">
                <h3><b>Get help submitting your injury and illness data</b></h3>
                <ul>
                    <li>First time using the ITA, or looking for help? Start at <a href="https://www.osha.gov/injuryreporting">OSHA's Injury Reporting page</a></li>
                    <li>Have a question about the requirements or using the ITA? Review the <a href="https://www.osha.gov/injuryreporting/faqs">ITA Frequently Asked Questions</a></li>
                    <li>Questions about recordkeeping? Visit <a href="https://www.osha.gov/recordkeeping">OSHA's Recordkeeping page</a></li>
                    <li>Need assistance? Submit a <a href="https://www.osha.gov/injuryreporting/ita/help-request-form">Help Desk ticket</a></li>
                    <li>Looking for OSHA’s publicly available ITA data? Visit <a href="https://www.osha.gov/Establishment-Specific-Injury-and-Illness-Data">OSHA’s ITA Data page</a></li>
                </ul>
              </div>
              <div className="divider"/>
            </div>
            <LoginWarningPage />
          </div>
          <LoginOMBMessage form={ombForm} secondForm={ombForm2}/>
        </div>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formErrors: PropTypes.object,
  loggingIn: PropTypes.bool.isRequired,
  passwordResetHidden: PropTypes.bool,
  submitStatus: PropTypes.bool,
  showSubmissionModal: PropTypes.func.isRequired,
  ombForm: PropTypes.object,
  ombForm2: PropTypes.object
};

export default LoginForm;



/** WEBPACK FOOTER **
 ** ./src/components/authentication/login/LoginForm.js
 **/